import React from 'react';
import '../../styles/about.scss';

export default function AboutRealtor(props) {
	return (
		<div className="top-padding-main">
			<div className="top-padding-medium d-sm-none  d-none d-md-block bottom-padding-medium">
				<div className="row ">
					<div className="col-md-6">
						{
							(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
								<h2 className="jost-bold">About Calque</h2> :
								<h2 className="jost-bold">About Our Partner</h2>
						}
						<p>The process of buying and selling a home is unnecessarily time-consuming, stressful and expensive for homeowners. After experiencing these frustrations first-hand, the team at Calque was inspired to re-imagine the home purchase process with consumers’ needs in mind. We {
							(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ? 'work with local lenders' : 'are working with  Calque and its lending partners'} to bring you a new, innovative home-purchase solution called The Trade-In Mortgage™. Together, we empower homeowners to use the equity in their current home so they can buy and move into their next home before they sell, giving consumers more convenience, more confidence, and more freedom throughout the entire process.</p>
					</div>
					<div className="col-md-6">
						<div className="row">
							<div className="about_img w-100">
								<img src="/assets/images/aboutuskey1_compressed.webp" alt="logo" ></img>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className=" d-sm-block d-md-none">
				<div className="row ">
					<div className="col-md-6">
						<h3 style={{ fontWeight: "700" }}>About Our Partner</h3>
						<p>The process of buying and selling a home is unnecessarily time-consuming, stressful and expensive for homeowners. After experiencing these frustrations first-hand, the team at Calque was inspired to re-imagine the home purchase process with consumers’ needs in mind. We are working with Calque and its lending partners to bring you a new, innovative home-purchase solution called The Trade-In Mortgage™. Together, we empower homeowners to use the equity in their current home so they can buy and move into their next home before they sell, giving consumers more convenience, more confidence, and more freedom throughout the entire process.</p>
					</div>
				</div>
			</div>
		</div>
	)
}